var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.options),function(item){return _c('a-radio',{key:item.code,attrs:{"title":item.code},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},[_vm._v(_vm._s(item.name)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }